import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const TabNavigation = ({ tabs, activeTab, setActiveTab, dropdownOpen, setDropdownOpen, handleTabChange, isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{
            backgroundColor: theme.panelBg,
            borderRadius: '5px',
            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
            marginBottom: isMobile ? '24px' : '34px',
            padding: isMobile ? '12px' : '17px',
            animation: 'bubbleAppear 0.5s ease-in-out'
        }}>
            {isMobile ? (
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        style={{
                            width: '100%',
                            padding: '12px 17px',
                            backgroundColor: theme.accent,
                            color: theme.statusBarText,
                            border: 'none',
                            borderRadius: '5px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            cursor: 'pointer',
                            fontFamily: 'monospace',
                            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                            fontSize: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            minHeight: '44px'
                        }}
                    >
                        <span>{tabs.find(tab => tab.id === activeTab)?.name || 'Select Tab'}</span>
                        <ChevronDown
                            size={20}
                            style={{
                                transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                            }}
                        />
                    </button>

                    {dropdownOpen && (
                        <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            right: '0',
                            backgroundColor: theme.panelBg,
                            borderRadius: '5px',
                            boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                            marginTop: '8px',
                            zIndex: 10,
                            overflow: 'hidden'
                        }}>
                            {tabs.map((tab, index) => (
                                <button
                                    key={tab.id}
                                    onClick={() => handleTabChange(tab.id)}
                                    style={{
                                        width: '100%',
                                        padding: '12px 17px',
                                        backgroundColor: activeTab === tab.id ? theme.accent : theme.cardBg,
                                        color: activeTab === tab.id ? theme.statusBarText : theme.text,
                                        border: 'none',
                                        borderBottom: index < tabs.length - 1 ? '1px solid rgba(40, 40, 40, 0.2)' : 'none',
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        cursor: 'pointer',
                                        fontFamily: 'monospace',
                                        fontSize: '18px',
                                        textAlign: 'left',
                                        transition: 'background-color 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeTab !== tab.id) {
                                            e.target.style.backgroundColor = theme.accent;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeTab !== tab.id) {
                                            e.target.style.backgroundColor = theme.cardBg;
                                        }
                                    }}
                                >
                                    {tab.name}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            ) : (
                <nav style={{
                    display: 'flex',
                    gap: '26px',
                    justifyContent: 'center',
                    flexWrap: 'wrap'
                }}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                padding: '17px 34px',
                                border: activeTab === tab.id ? `3px solid ${theme.accent}` : '3px solid transparent',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                backgroundColor: activeTab === tab.id ? theme.accent : theme.cardBg,
                                color: activeTab === tab.id ? theme.statusBarText : theme.text,
                                cursor: 'pointer',
                                transition: 'transform 0.3s ease',
                                fontFamily: 'monospace',
                                boxShadow: '0 4px 7px rgba(40, 40, 40, 1)',
                                fontSize: '20px',
                                minHeight: '44px'
                            }}
                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            )}
        </div>
    );
};

export default TabNavigation;
